import { render, staticRenderFns } from "./clientLink.vue?vue&type=template&id=32f7dc84&"
import script from "./clientLink.vue?vue&type=script&lang=js&"
export * from "./clientLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports